interface BellIconProps {
  color?: string;
}

export const BellIcon = ({ color = "#676560" }: BellIconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.82528 1.23859C5.77152 0.388371 6.96664 0 8 0C9.03336 0 10.2285 0.388371 11.1747 1.23859C12.138 2.10412 12.8205 3.42957 12.8205 5.22701V8.92898L15 13.5917H10.6605C10.5504 14.2605 10.2679 14.8119 9.86498 15.2209C9.34729 15.7463 8.66697 16 8 16C7.33303 16 6.65271 15.7463 6.13502 15.2209C5.73214 14.8119 5.44957 14.2605 5.33953 13.5917H1L3.1795 8.92898V5.22701C3.1795 3.42957 3.86201 2.10412 4.82528 1.23859ZM6.57521 13.5917C6.65928 13.8934 6.80095 14.121 6.96515 14.2876C7.23833 14.5649 7.61248 14.7126 8 14.7126C8.38752 14.7126 8.76167 14.5649 9.03485 14.2876C9.19905 14.121 9.34072 13.8934 9.42479 13.5917H6.57521ZM5.60102 2.22378C4.90725 2.84715 4.38463 3.81336 4.38463 5.22701V9.23252L2.94876 12.3043H13.0512L11.6154 9.23252V5.22701C11.6154 3.81336 11.0928 2.84715 10.399 2.22378C9.68818 1.58511 8.77432 1.28736 8 1.28736C7.22568 1.28736 6.31182 1.58511 5.60102 2.22378Z"
        fill={color}
      />
      <path d="M4.38463 5.22701C4.38463 3.81336 4.90725 2.84715 5.60102 2.22378C6.31182 1.58511 7.22568 1.28736 8 1.28736C8.77432 1.28736 9.68818 1.58511 10.399 2.22378C11.0928 2.84715 11.6154 3.81336 11.6154 5.22701V9.23252L13.0512 12.3043H2.94876L4.38463 9.23252V5.22701Z" />
    </svg>
  );
};
